import { render, staticRenderFns } from "./SelectGoodsDialog.vue?vue&type=template&id=eb70abc4&scoped=true&"
import script from "./SelectGoodsDialog.vue?vue&type=script&lang=js&"
export * from "./SelectGoodsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb70abc4",
  null
  
)

export default component.exports